export const classesI18n = {
  en: {
    title: 'Classes',
    classesForInstitution: 'Classes for {institution} institution',
    classesForDepartment: 'Classes for {departmentName} department',
    editSchedule: 'Edit Schedule',
    className: 'Class Name',
    department: 'Department',
    addClass: 'Add Class',
    inactivate: 'Move to previous calendar classes',
    inactiveClasses: 'Previous Calendar Classes',
    consolidatedHomeworks: 'Consolidated Homeworks',
    consolidatedHomeworksTitle: 'Consolidated Homeworks for Class: {className} - {subjectName}',
    invite: 'Invite',
    confirmRemoveClass: 'This action will remove all the class related info (Submitted tasks, subjects, feedback, students and teachers). Are you sure you want to remove the class {className}?',
    confirmInactivateClass: 'This action will move this class to Previous Calendar Classes. This cannot be undone. Are you sure you want to move the class {className}?',
    loadingItems: 'Loading items',
    noDataAvailable: 'No data available',
    viewStudents: 'View students',
    viewCourses: 'View subjects',
    added: 'Added to class',
    goBack: 'Go Back',
    builder: 'Builder',
    builders: {
      byClass: 'By Class',
      byTeacher: 'By Teacher',
      byGrade: 'By Grade'
    },
    placeholder: {
      add: 'Add Placeholder',
      empty: 'You don’t have placeholders yet. You can create some',
      itemTooltip: 'The hours of this placeholder on the school calendar',
      allowTeacherToEdit: 'Allow teacher to modify',
      creating: {
        title: 'Creating placeholder',
        support: 'Set a reference name for the subject type that it has to be on selected blocks'
      },
      toBlock: {
        title: 'Adding subjects to blocks',
        support: 'Select subjects that you want to assign to the selected blocks',
        check: 'Add this to all sections of this block - if not it will only affect this one section of the block',
      },
      subject: {
        title: 'Assing subjects',
        support: 'Select the Subjects that you want to assign to the placeholders created',
        select: 'Assign subject'
      }
    },
    calendar: {
      title: 'Class Calendar',
      assign: {
        title: 'Selecting the subject for each day',
        support: 'You have to select the specific subject for each day of the calendar or the first subject or the first subject will be selected by default',
      }
    },
    schedule: {
      addBlocks: 'Add blocks',
      sidebarMessageWithBlocks: 'Create the blocks that you need for the schedule',
      sidebarMessageWithoutBlocks: 'You have not created any blocks yet',
      creating: {
        title: 'Creating a block',
        support: 'Set a name if you want to have a clear reference of the block'
      },
      deleting: {
        title: 'Delete a block',
        support: 'Are you sure you want to remove this block?'
      },
      workingDays: {
        title: 'Set Working Days',
        support: 'Set the working days of calendar',
      }
    },
    students: {
      studentsForClass: 'Students for {className} class',
      confirmRemove: 'This action will remove posible answers submitted by the student. Are you sure you want to remove the student {studentName} from the class {className}? ',
      addStudent: 'Add student to class',
      removeStudent: 'Remove student from class',
      classStudents: 'Class Students'
    },
    teachers: {
      teachersForClass: 'Teachers for {className} class',
      confirmRemove: 'Are you sure you want to remove the teacher {teacherName} from the class {className}?',
      addTeacher: 'Add teacher to class',
      removeTeacher: 'Remove teacher from class',
      updateMainTeacher: 'Update Main Teacher',
      classTeachers: 'Class Teachers',
      confirmMainTeacher: 'Are you sure you want to add {teacherName} as the Main Teacher for the class {className}?',
      coTeacher: 'Co-Instructor',
      courseTeacher: 'Subject Teacher',
      substituteTeacher: 'Substitute Teacher',
      viewAllTeachers: 'View all teachers'
    },
    courses: {
      settings: 'Settings',
      coursesForClass: 'Subjects for {className} class',
      confirmRemove: 'This action will remove all the subject related info (Tasks submitted).  Are you sure you want to remove the subjects {courseName} from the class {className}?',
      addCourse: 'Add Subjects',
      addQuickSubject: 'Add Quick Add Subject',
      updateQuickSubject: 'Update Curso rápido',
      addCourseClass: 'Add subject to class',
      removeCourse: 'Remove subject from class',
      classCourses: 'Class Subjects',
      editCourseInfo: 'Edit subject config',
      courseAccess: 'Subject Teachers',
      extendDueDate: 'Last date to submit',
      viewContent: 'Only allow students to view the subject content in the defined timeframe.',
      courseTeachers: 'Subject Teachers',
      shareCourse: 'Share Subject',
      blockCourse: 'Block Subject for sharing',
      changeOwner: 'Change Owner',
      confirmChangeOwner: 'Are you sure you want to update the subject {courseName} owner to {owner}',
      coEditor: 'Co-editor',
      addCoEditor: 'Add Co-editor',
      removeCoEditor: 'Remove Co-editor',
      updateOwner: 'Update Owner',
      template: 'Template',
      selectTemplate: 'Select a template to create the subject',
      subject: 'Subject',
      quickAddSubject: 'Quick Add Subject',
      confirmRemoveQuickSubject: 'This action will remove all the blocks associated to this subject on the Class Builder. Are you sure you want to remove the subject {courseName} from the class {className}?',
      subjectBuilder: 'Subject Builder',
      calendarExpired:'The calendar of the class is expired',
    },
    errors: {
      mainTeacherNoUpdated: 'Could not update main teacher',
      classNoUpdated: 'The class could not be updated',
      classNoDeleted: 'The class could not be removed',
      classNoInactivated: 'The class could not be moved to Previous Calendar Classes',
      classNoAdded: 'The class could not be added',
      studentNoAdded: 'The student could not be added',
      teacherNoAdded: 'The teacher could not be added',
      studentNoRemoved: 'The student could not be removed',
      teacherNoRemoved: 'The teacher could not be removed',
      courseInfoNoUpdated: 'Subject info could not update succesfully',
      ownerNoUpdated: 'The subject owner could not update successfully',
      coEditorNoAdded: 'The Co-editor could not be added successfully',
      coEditorNoRemoved: 'The Co-editor could not be removed successfully',
      courseNoBlocked: 'Subject could not be blocked successfully',
      courseNoUnblocked: 'Subject could not be unblocked successfully',
      errorSavingQuickSubject: 'There was an error trying to save the subject. Please try again.',
      courseNoRemoved: 'The course could not be removed'
    },
    success: {
      studentAdded: 'Student added successfully to the class',
      studentRemoved: 'Student removed successfully from the class',
      teacherAdded: 'Teacher added successfully to the class',
      teacherRemoved: 'Teacher removed successfully from the class',
      mainTeacherUpdated: 'The main teacher was updated successfully',
      classUpdated: 'Class updated successfully',
      classDeleted: 'Class removed successfully',
      classInactivated: 'Class moved successfully',
      classAdded:  'Class added successfully',
      courseRemoved: 'Subject removed successfully',
      courseAdded: 'Subject added successfully',
      courseInfoUpdated: 'Subject info updated succesfully',
      ownerUpdated: 'The subject owner was updated successfully',
      coEditorAdded: 'Co-editor added successfully',
      coEditorRemoved: 'Co-editor removed successfully',
      courseBlocked: 'Subject blocked successfully',
      courseUnblocked: 'Subject unblocked successfully',
      quickSubjectSaved: 'Quick add subject saved successfully'
    },
    info: {
      addClassDisclamer: 'You will be able to add Subjects, Teachers and Students after the class is created.',
      extendDueDateDisclamer: 'The subject content due date can be extended the number of days defined.',
      viewContentDisclamer: 'This check allows students to view only the content associated to the set timeframe.',
      editCourseDisclamer: 'You are updating info from the {courseName} subject.',
      cantEdit: 'You can see the subject config, but you can\'t edit it.',
      confirmCourseAccessTrue: 'By enabling this flag you are allowing the Main Teacher and Co-instructors to see all subjects content from the class.',
      confirmCourseAccessFalse: 'By disabling this flag you are allowing \'Teachers by subject\' feature and your current Main teacher and Co-instructors won\'t be able to access the class subjects content.  You can add Subject Teachers on the Subjects section.',
      infoCourseAccessTrue: 'Enable to allow access to all subjects in this class to the teachers.',
      infoCourseAccessFalse: 'Disable to assign a teacher to each subject individually.',
      addCourseTeacherDisclaimer: 'You can add/edit Subject Teachers by clicking on add/edit subject actions.',
      courseTeachersDisclaimer: 'Currently the Main Teacher and Co-instructors cannot access subjects, you must add Subject Teachers on the Subjects section.',
      shareCourseInfo: 'You can change the owner and share the subject {course} with the users listed bellow',
      blockCourseInfo: 'Check to block users the options to update the owner or invite co-editors to the subject.',
      selectScale: 'Please select the method that will be used to grade tasks in this subject.',
      noPermission: 'No permissions',
      needToHaveSchedule: 'It has to be added to a Schedule',
      userClassesUpdatedWarning: 'The classes and subjects information related with the organization was updated. Please refresh the page to see the latest information.',
      classEndedDisclaimer: 'The class ended at {endDate}. You can view the information, but you cannot make any changes.',
    },
    headers: {
      username: 'Username',
      name: 'Name',
      lastName: 'Last Name',
      email: 'Email',
      mainTeacher: 'Main Teacher',
      grades: 'Grades',
      schoolCalendar: 'School Calendar',
      capacity: 'Capacity',
      enrollment: 'Enrollment',
      visibility: 'Visibility',
      schedule: 'Schedule',
      classBuilder: 'Class builder',
      actions: 'Actions',
      courseAccess: 'All Subjects Access',
      students: 'Students',
      courses: 'Subjects',
      courseName: 'Subject Name',
      createdBy: 'Created By',
      assignedTo: 'Assigned to',
      type: 'Type',
      teacherType: 'Teacher Type',
      teachers: 'Teachers',
      owner: 'Owner',
      date: 'Date',
    }
  },
  es: {
    title: 'Clases',
    classesForInstitution: 'Clases para la institución {institution}',
    classesForDepartment: 'Clases para el departamento {departmentName}',
    editSchedule: 'Editar horario',
    className: 'Nombre de la clase',
    department: 'Departamento',
    addClass: 'Agregar Clase',
    inactiveClasses: 'Clases de calendarios anteriores',
    consolidatedHomeworks: 'Consolidado de tareas',
    consolidatedHomeworksTitle: 'Consolidado de tareas para la clase: {className} - {subjectName}',
    invite: 'Invitar',
    confirmRemoveClass: 'Esta acción eliminará toda la información relacionada con la clase (Tareas enviadas, comentarios, cursos, estudiantes y profesores).  ¿Está seguro de que desea eliminar la clase {className}?',
    confirmInactivateClass: 'Esta acción moverá esta clase a Clases de Calendario Anteriores. Esta acción no se puede deshacer. ¿Está seguro de que desea mover la clase {className}?',
    loadingItems: 'Cargando items',
    noDataAvailable: 'No hay datos disponibles',
    viewStudents: 'Ver estudiantes',
    viewCourses: 'Ver cursos',
    added: 'Agregado a la clase',
    goBack: 'Atrás',
    builder: 'Constructor',
    builders: {
      byClass: 'Por clase',
      byTeacher: 'Por profesor',
      byGrade: 'Por grado',
    },
    schedule: {
      addBlocks: 'Agregar bloques',
      sidebarMessageWithBlocks: 'Crea los bloques que necesites para tu horario',
      sidebarMessageWithoutBlocks: 'Aun no has agregado bloques de horario',
      creating: {
        title: 'Creando un bloque',
        support: 'Colocale un nombre al bloque si quieres una referencia clara',
      },
      deleting: {
        title: 'Eliminar bloque',
        support: '¿Seguro que quiere eliminar este bloque?'
      },
      workingDays: {
        title: 'Establecer días de escolares',
        support: 'Establecer los días escolares del calendario.',
      }
    },
    placeholder: {
      add: 'Agregar placeholder',
      empty: 'No hay placeholders, agrega uno',
      itemTooltip: 'Las horas de este placeholder en el calendario escolar',
      allowTeacherToEdit: 'Permitir a los profesores editar',
      creating: {
        title: 'Creando placeholder',
        support: 'Establecer un nombre de referencia para el tipo de asignatura que debe estar en los bloques seleccionados.'
      },
      toBlock: {
        title: 'Agregando Materia',
        support: 'Seleccione las materias que desea asignar a los bloques seleccionados.',
        check: 'Agregar esto a todas las secciones de este bloque - de lo contrario, solo afectará a esta sección del bloque.',
      },
      subject: {
        title: 'Asignar asignaturas',
        support: 'Selecciona la asignatura que quieres agregar a los placeholder creados.',
        select: 'Asignar asignatura',
      }
    },
    calendar: {
      title: 'Calendario de la clase',
      assign: {
        title: 'Seleccionando la asignatura para cada día.',
        support: 'Tienes que seleccionar una asignatura en específico para cada día del calendario o la primera asignatura será seleccionado por defecto.',
      }
    },
    students: {
      studentsForClass: 'Estudiantes para la clase {className}',
      confirmRemove: 'Esta acción eliminará las posibles respuestas enviadas por el estudiante.  ¿Está seguro de que desea remover al estudiante {studentName} de la clase {className}?',
      addStudent: 'Agregar estudiante a la clase',
      removeStudent: 'Remover estudiante de la clase',
      classStudents: 'Estudiantes de clase'
    },
    teachers: {
      teachersForClass: 'Profesores para la clase {className}',
      confirmRemove: '¿Está seguro de que desea remover al profesor {teacherName} de la clase {className}?',
      addTeacher: 'Agregar profesor a la clase',
      removeTeacher: 'Remover profesor de la clase',
      updateMainTeacher: 'Actualizar profesor principal',
      classTeachers: 'Profesores de clase',
      confirmMainTeacher: '¿Está seguro de que desea asignar a {teacherName} como Profesor Principal de la clase {className}?',
      coTeacher: 'Co-Instructor',
      courseTeacher: 'Profesor de Curso',
      substituteTeacher: 'Profesor substituto',
      viewAllTeachers: 'Ver todos los profesores'
    },
    courses: {
      settings: 'Ajustes',
      coursesForClass: 'Cursos para la clase {className}',
      confirmRemove: 'Esta acción eliminará toda la información relacionada con el curso (Tareas enviadas).  ¿Está seguro de que desea remover el curso {courseName} de la clase {className}?',
      addCourse: 'Agregar Cursos',
      addQuickSubject: 'Crear Curso rápido',
      updateQuickSubject: 'Actualizar Curso rápido',
      addCourseClass: 'Agregar curso a la clase',
      removeCourse: 'Remover curso de la clase',
      classCourses: 'Cursos de clase',
      editCourseInfo: 'Editar la configuración del curso',
      courseTeachers: 'Profesores de curso',
      extendDueDate: 'Última fecha para enviar',
      viewContent: 'Permitir que los estudiantes solo vean el contenido del curso en el periodo de tiempo definido.',
      shareCourse: 'Compartir curso',
      blockCourse: 'Bloquear curso para compartir',
      changeOwner: 'Cambiar propietario',
      confirmChangeOwner: 'Está seguro de que desea cambiar el propietario del curso {courseName} por {owner}',
      coEditor: 'Co-editor',
      addCoEditor: 'Agregar Co-editor',
      removeCoEditor: 'Remover Co-editor',
      updateOwner: 'Actualizar propietario',
      template: 'Plantilla',
      selectTemplate: 'Seleccione una plantilla para crear el curso',
      subject: 'Curso',
      quickAddSubject: 'Curso Rápido',
      confirmRemoveQuickSubject: 'Esta acción borrará todos los bloques asociados a este curso en el Constructor de Clases. ¿Está seguro de que desea remover el curso {courseName} de la clase {className}?',
      subjectBuilder: 'Constructor de curso',
      calendarExpired:'El calendario de la clase está expirado',
    },
    errors: {
      mainTeacherNoUpdated: 'No se pudo actualizar el profesor principal',
      classNoUpdated: 'La clase no pudo ser actualizada',
      classNoDeleted: 'La clase no pudo ser eliminada',
      classNoInactivated: 'La clase no pudo ser movida a clases de calendarios anteriores',
      classNoAdded: 'La clase no pudo ser agregada',
      studentNoAdded: 'El estudiante no pudo ser agregado',
      teacherNoAdded: 'El profesor no pudo ser agregado',
      studentNoRemoved: 'El estudiante no pudo ser eliminado',
      teacherNoRemoved: 'El profesor no pudo ser eliminado',
      courseInfoNoUpdated: 'El curso no pudo ser actualizado',
      ownerNoUpdated: 'El propietario del curso no pudo ser actualizado',
      coEditorNoAdded: 'El Co-editor no pudo ser agregado',
      coEditorNoRemoved: 'El Co-editor no pudo ser eliminado',
      courseNoBlocked: 'El curso no pudo ser bloqueado',
      courseNoUnblocked: 'El curso no pudo ser desbloqueado',
      errorSavingQuickSubject: 'Hubo un problema guardando el curso. Por favor, intente nuevamente',
      courseNoRemoved: 'El curso no pudo ser eliminado'
    },
    success: {
      studentAdded: 'El estudiante fue agregado a la clase con éxito',
      studentRemoved: 'El estudiante fue removido de la clase con éxito',
      teacherAdded: 'El profesor fue agregado a la clase con éxito',
      teacherRemoved: 'El profesor fue removido de la clase con éxito',
      mainTeacherUpdated: 'El profesor principal fue actualizado con éxito',
      classUpdated: 'La clase fue actualizada con éxito',
      classDeleted: 'La clase fue eliminada con éxito',
      classInactivated: 'La clase fue movida a Clases de Calendarios Anteriores con éxito',
      classAdded: 'La clase fue agregada con éxito',
      courseRemoved: 'El curso fue eliminado con éxito',
      courseAdded: 'El curso fue agregado con éxito',
      courseInfoUpdated: 'El curso fue actualizado con éxito',
      ownerUpdated: 'El propietario del curso fue actualizado con éxito',
      coEditorAdded: 'El Co-editor fue agregado con éxito',
      coEditorRemoved: 'El Co-editor fue removido con éxito',
      courseBlocked: 'El curso fue bloqueado con éxito',
      courseUnblocked: 'El curso fue desbloqueado con éxito',
      quickSubjectSaved: 'El curso fue creado con éxito'
    },
    info: {
      addClassDisclamer: 'Podrás agregar Cursos, Profesores y Estudiantes después de la creación de la clase.',
      extendDueDateDisclamer: 'La fecha de expiración de los contenidos del curso, se podrá aplazar por el numero de dias definido.',
      viewContentDisclamer: 'Esta verificación permite al estudiante ver solo el contenido asociado al periodo de tiempo establecido.',
      editCourseDisclamer: 'Está editando información del curso {courseName}.',
      cantEdit: 'Puede ver la configuración del curso pero no puede editarla.',
      addCourseTeacherDisclaimer: 'Puede agregar/editar Profesores de Curso haciendo click en las acciones de agregar/editar curso.',
      confirmCourseAccessTrue: 'Al habilitar esta opción, el Profesor Principal y los Co-instructores tendrán acceso a todos los cursos de la clase.',
      confirmCourseAccessFalse: 'Al deshabilitar esta opción, se habilitará la función de \'Instructores por curso\' y el Profesor Principal y los Co-instructores actuales no podrán acceder a los cursos de la clase. Podrá agregar Instructores de Cursos en la sección de Cursos.',
      infoCourseAccessTrue: 'Habilite para permitir el acceso a todos los profesores a todos los cursos de esta clase.', 
      infoCourseAccessFalse: 'Deshabilite para asignar un profesor a cada curso individualmente.',
      courseTeachersDisclaimer: 'Actualmente el Profesor Principal y los Co-instructores no tienen acceso a los cursos, debe agregar Profesores de Curso en la sección de Cursos.',
      shareCourseInfo: 'Puede cambiar el propietario y compartir el curso {course} con los usuarios listados aquí.',
      blockCourseInfo: 'Habilita para bloquear a usuarios las opciones de cambiar el propietario e invitar co-editores al curso.',
      selectScale: 'Seleccione el método que será usado para calificar las tareas en este curso.',
      noPermission: 'Sin permisos',
      needToHaveSchedule: 'El curso debe estar agregado a un horario',
      userClassesUpdatedWarning: 'La información relacionada con las clases y cursos de la organización fueron actualizados. Por favor recargue la pagina para ver la ultima información.',
      classEndedDisclaimer: 'La clase finalizó el {endDate}. Puedes ver la información, pero no puedes hacer ningún cambio.',
    },
    headers: {
      username: 'Usuario',
      name: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo',
      mainTeacher: 'Profesor principal',
      grades: 'Calificaciones',
      schoolCalendar: 'Calendario escolar',
      capacity: 'Capacidad',
      enrollment: 'Inscripción',
      visibility: 'Visibilidad',
      schedule: 'Horario',
      classBuilder: 'Constructor de clase',
      actions: 'Acciones',
      courseAccess: 'Acceso a cursos',
      students: 'Estudiantes',
      courses: 'Cursos',
      courseName: 'Nombre del curso',
      owner: 'Propietario',
      assignedTo: 'Asignado a',
      type: 'Tipo', 
      teacherType: 'Tipo de profesor',
      teachers: 'Profesores',
    }
  }
};